function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGenericBankAccount = function SvgGenericBankAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 11.4c-.3-.2-.8-.2-1.1 0l-5.2 3.5c-.2.1-.4.2-.6.2H12v2h1c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-1v2h16v-2h-1c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1h1v-2h-1.7c-.2 0-.4-.1-.6-.2l-5.1-3.5zM24 18c0-.6-.4-1-1-1h-1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-6zm-6-1c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgGenericBankAccount;